import { Fragment, useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { NavLink } from "react-router-dom";

import { getDateFormatted, getQuery, getBadget, getEdgeTensorStatusOptions } from 'Core/data/Helpers';
import { Grid, Typography, Container, Paper, Divider, Icon } from "@mui/material";
import DataView from 'Components/DataView';
import { Select, Tooltip, Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import Filters from 'Components/Filters';

import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';

//Notification
import { NotificationManager } from "Components/Notifications";

//Views
import RawMessageView from 'Modules/devices/.components/rawMessageView'
import EdgeTensorVideoReview from "../edgeTensorVideoReview";
import CustomSelect from 'Components/Select';

//Permission
import { HasPermission } from "Core/security";

//Actions
import { searchAiVideoReviewsByAccount, reset, getDevices } from './redux/slice';
import { getAccounts } from 'Modules/activities/views/main/redux/saga';
//import { getDevices } from 'Modules/devices/views/overview/.components/associateToGps/redux/saga';

import {
    rawMessageViewOpenModal,
    openModalEdgeTensorVideoReview
} from "Redux/actions";

//Styles
import './main.scss';

const TabEdgeTensor = (props) => {
    const { height, mode, company } = props;
    const tableRef = useRef();
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const current_week = moment().startOf('week');
    const tempStartDate = new Date(current_week.toString());
    const [startDate, setStartDate] = useState(tempStartDate);
    const [endDate, setEndDate] = useState(new Date());
    const [beforeRangeDate, setBeforeRangeDate] = useState({
        start: startDate,
        end: endDate
    })
    const [status, setStatus] = useState(null);

    const [filters, setFilters] = useState({
        startDate: startDate,
        endDate: endDate,
        page: 1,
        limit: 100,
        sort: [{ field: 'unitTime', order: 'DESC' }],
        offset: 0

    })

    //Redux States
    const { loading, items, total, accountParam, loadingEdgeTensor, nextToken } = useSelector(state => state.edgeTensorRedux);
    const openModalRawMessage = useSelector(state => state.rawMessageViewRedux.openModal);
    const lang = useSelector(state => state.commonRedux.language);
    const user = useSelector(state => state.securityRedux.user);
    const edgeTensorVideoReviewOpenModal = useSelector(state => state.edgeTensorVideoReviewRedux.openModal);
    const openModalEdgeTensor = useSelector(state => state.edgeTensorRedux.openModal);
    const loadingAccounts = useSelector(state => state.activitiesMainRedux.loadingAccounts);
    const loadingDevices = useSelector(state => state.associateToGpsRedux.loadingDevices);

    //Local States
    const [last, setLast] = useState({ id: '20', name: '20' });
    const [type, setType] = useState('range');
    const [conditions, setConditions] = useState([]);
    const [account, setAccount] = useState(company || accountParam || null);
    const [device, setDevice] = useState(null);
    const [rawData, setRawData] = useState("");
    const [columns, setColumns] = useState([
        {
            key: 'raw_data',
            show: true,
            locked: true,
            title: "",
            width: 40,
            icon: true,
            render: (item) => {
                return (
                    <Tooltip title={messages['edge_tensor_tab_raw_message']} placement="top">
                        <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon fs-20" onClick={() => {
                            let rawData = cloneDeep(item)
                            if (item?.response) {
                                rawData.response = JSON.parse(item.response);
                            }
                            if (item?.data) {
                                rawData.data = JSON.parse(item.data);
                            }
                            dispatch(rawMessageViewOpenModal(true, rawData, `${messages['edge_tensor_tab_raw_message']} - ${item.rowId}`, false, null))
                        }}>
                            remove_red_eye
                        </Icon>
                    </Tooltip>
                )
            }
        },
        {
            key: 'review',
            show: true,
            locked: true,
            title: "",
            width: 40,
            icon: true,
            position: 1,
            render: (item) => {

                if (item.status === "Pending")
                    return <span></span>

                let data = {
                    rowId: item.rowId,
                    accountId: item.accountId,
                    deviceId: item.deviceId,
                    url: null,
                    eventName: item.eventName,
                    tab: 0
                }

                if (!item?.resultEventNames) {
                    data.onlyVideo = true;
                    return (
                        <Tooltip title={messages['edge_tensor_tab_open_video']} placement="top">
                            <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon fs-20" onClick={() => {
                                dispatch(openModalEdgeTensorVideoReview({ data }))
                            }} >
                                ondemand_video
                            </Icon>
                        </Tooltip>
                    )
                } else
                    return (
                        <Tooltip title={messages['edge_tensor_tab_event_review']} placement="top">
                            <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon fs-20" onClick={() => {
                                if (HasPermission(user, "edgtnsrvdrvrw")) {
                                    dispatch(openModalEdgeTensorVideoReview({ data }))
                                } else {
                                    NotificationManager.warning(
                                        messages['common_error_permission'],
                                        messages['edge_tensor_tab_title'],
                                        5000,
                                    );
                                }
                            }} >
                                assignment
                            </Icon>
                        </Tooltip>
                    )
            }
        },
        {
            key: 'rowId',
            field: 'rowId',
            show: true,
            locked: false,
            title: messages["edge_tensor_tab_row_id"],
            width: 100,
            exportCell: "rowId",
            export: true,
            functionString: 'return row?.rowId',
            code: "edge_tensor_tab_row_id",
        },
        {
            key: 'unitId',
            field: 'unitId',
            show: true,
            locked: false,
            sort: true,
            title: messages["edge_tensor_tab_device_id"],
            width: 200,
            exportCell: "deviceId",
            export: true,
            functionString: 'return row?.deviceId',
            code: "edge_tensor_tab_device_id",
            render: (item) => {
                return (
                    <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        className="context-menu-container"
                        wrap="nowrap"
                    >
                        <Grid item>
                            <NavLink to={`/app/devices/overview/${item?.deviceId}`} style={{ color: 'black' }}>
                                <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{item?.deviceId}</span>
                            </NavLink>
                        </Grid>
                    </Grid>
                )
            }
        },
        {
            key: 'status',
            field: 'status',
            show: true,
            locked: false,
            sort: true,
            title: messages["edge_tensor_tab_status"],
            width: 100,
            exportCell: "status",
            export: true,
            functionString: 'return row?.status',
            code: "edge_tensor_tab_status",
            render: (item) => {
                return getBadget(messages[`edge_tensor_tab_status_${item.status.toLowerCase()}`] || item.status, null, item.status);
            }
        },
        {
            key: 'unitTime',
            field: 'unitTime',
            show: true,
            locked: false,
            sort: true,
            title: messages["edge_tensor_tab_unit_time"],
            width: 300,
            exportCell: "unitTime",
            export: true,
            functionString: `
                function formatDate(date, timezone) {
                    let dateToformat = moment(date).tz(timezone)
                    let formatted = moment(dateToformat).format("YYYY/MM/DD HH:mm:ss")
                    return formatted;
                }
                let timezone = "${account?.timezone}"
                return row?.unitTime ? formatDate(row?.unitTime, timezone) : ''
            `,
            code: "edge_tensor_tab_unit_time",
            render: (item) => {
                return (
                    <Fragment>
                        {
                            item.unitTime && getDateFormatted(item.unitTime, "date", "datetime", null, account?.timezone)
                        }
                    </Fragment>
                )
            }
        },
        {
            key: 'createdOn',
            field: 'createdOn',
            show: true,
            locked: false,
            title: messages["edge_tensor_tab_created_on"],
            width: 300,
            exportCell: "createdOn",
            export: true,
            functionString: `
                function formatDate(date, timezone) {
                    let dateToformat = moment(date).tz(timezone)
                    let formatted = moment(dateToformat).format("YYYY/MM/DD HH:mm:ss")
                    return formatted;
                }
                let timezone = "${account?.timezone}"
                return row?.createdOn ? formatDate(row?.createdOn, timezone) : ''
            `,
            code: "edge_tensor_tab_created_on",
            render: (item) => {
                return (
                    <Fragment>
                        {
                            item.createdOn &&
                            getDateFormatted(item.createdOn, "date", "datetime", null, account?.timezone)
                        }
                    </Fragment>
                )
            }
        },
        {
            key: 'processTime',
            show: true,
            locked: false,
            title: messages["edge_tensor_tab_process_time"],
            width: 180,
            export: true,
            functionString: `
                function processTime(startDate, endDate) {
                    let start = moment(startDate);
                    let end   = moment(endDate);
                    let formatted = moment.duration(end.diff(start)).humanize();
                    return formatted;
                }
                return row?.updatedOn ? processTime(row?.createdOn,row?.updatedOn) : ''
            `,
            code: "edge_tensor_tab_process_time",
            render: (item) => {
                let formatted = "";
                if (item.createdOn && item.updatedOn) {
                    // Calculate the time difference between createdOn and updatedOn
                    // and format it to a human-readable string
                    let start = moment(item.createdOn);
                    let end = moment(item.updatedOn);
                    formatted = moment.duration(end.diff(start)).humanize();
                }
                return (
                    <Fragment>
                        {
                            item.updatedOn &&
                            <span>{formatted}</span>
                        }
                    </Fragment>
                )
            }
        },
        {
            key: 'eventName',
            field: 'eventName',
            show: true,
            locked: false,
            sort: true,
            title: messages["edge_tensor_tab_event_name"],
            width: 200,
            exportCell: "eventName",
            export: true,
            functionString: 'return row?.eventName',
            code: "edge_tensor_tab_event_name",
            render: (item) => {
                return <span>{item.eventName}</span>
            }
        },
        {
            key: 'result_events',
            field: 'eventResult',
            show: true,
            locked: false,
            title: messages["edge_tensor_tab_result_events"],
            width: 400,
            exportCell: "eventResult",
            export: true,
            functionString: 'return row?.resultEventNames ? row.resultEventNames.replace(/,/g, " - ") : ""',
            code: "edge_tensor_tab_result_events",
            render: (item) => {

                if (item.status === "Complete" && !item?.resultEventNames)
                    return (<div key={0} className="d-sm-inline-block mb-1 vidfleet-pills">
                        {getBadget(messages["edge_tensor_no_events"], false)}
                    </div>)
                if (!item?.resultEventNames) return <span></span>;
                let eventNames = item?.resultEventNames.split(',')
                return eventNames.map((eventName, index) => (
                    <div key={index} className="d-sm-inline-block mb-1 vidfleet-pills">
                        {getBadget(eventName.trim(), true, null, eventName.trim() === item.eventName.trim() ? "#66BA6F" : "#FF0000", () => {
                            let data = {
                                rowId: item.rowId,
                                accountId: item.accountId,
                                deviceId: item.deviceId,
                                url: null,
                                eventName: item.eventName,
                                tab: 1
                            }

                            if (HasPermission(user, "edgtnsrvdrvrw")) {
                                dispatch(openModalEdgeTensorVideoReview({ data }))
                            } else {
                                NotificationManager.warning(
                                    messages['common_error_permission'],
                                    messages['edge_tensor_tab_title'],
                                    5000,
                                );
                            }

                        })}
                    </div>
                ));
            }
        },
        {
            key: 'reviewStatus',
            field: 'reviewStatus',
            show: true,
            locked: false,
            title: messages["edge_tensor_tab_review_status"],
            width: 200,
            exportCell: "reviewStatus",
            export: true,
            functionString: `
                let videoReview = null;
                try {
                    videoReview = row?.deviceReading?.videoReview ? JSON.parse(row?.deviceReading?.videoReview) : null;
                } catch (error) {}
                if(!videoReview?.status) return ''
                return videoReview.status;
                `,
            code: "edge_tensor_tab_review_status",
            render: (item) => {
                if (!item?.deviceReading?.videoReview) return <span></span>

                let videoReview = null
                try {
                    videoReview = JSON.parse(item?.deviceReading?.videoReview)
                } catch (error) { }

                if (!videoReview?.status) return <span></span>
                return (
                    <span>{videoReview.status}</span>
                )
            }
        },
        {
            key: 'videoUrl',
            field: 'videoUrl',
            show: false,
            locked: false,
            title: messages["edge_tensor_tab_video_url"],
            width: 200,
            exportCell: "videoUrl",
            export: true,
            functionString: `
                let deviceData = null;
                try {
                    deviceData = row?.deviceReading?.deviceData ? JSON.parse(JSON.parse(row?.deviceReading?.deviceData)) : null;
                } catch (error) {}
                return deviceData?.url || '';
                `,
            code: "edge_tensor_tab_video_url",
            render: (item) => {
                let deviceData = null;
                try {
                    deviceData = item?.deviceReading?.deviceData ? JSON.parse(JSON.parse(item?.deviceReading?.deviceData)) : null;
                } catch (error) { }
                return (
                    <span>{deviceData?.url}</span>
                )
            }
        }

    ])

    const selectStyles = {
        menuPortal: base => ({ ...base, zIndex: 9999 })
    };

    const loadInitData = (sugestFilters, paggingFilters, reload, tags, rows, fromPreferences, gridSort, offset) => {

        if (reload) {
            dispatch(reset({ items: [], total: 0 }))
        }

        let currentConditions = [];

        let currentFilters = filters
        if (sugestFilters) {
            currentFilters = sugestFilters;
        }

        if (account) {
            currentConditions.push({
                "fields": [
                    "accountId"
                ],
                "terms": [account?.id],
                "exact": true
            });
        }
        if (device) {
            currentConditions.push({
                "fields": [
                    "unitId"
                ],
                "terms": [device?.esn],
                "exact": true
            });
        }

        if (status) {
            currentConditions.push({
                "fields": [
                    "status"
                ],
                "terms": [status?.id],
                "exact": true
            });
        }

        const start = moment(startDate).utc()
        const end = moment(endDate).set({ hour: 23, minute: 59, second: 0, millisecond: 0 }).utc()
        currentFilters.startDate = start.format("YYYY-MM-DDTHH:mm:ss.sss") + "Z";
        currentFilters.endDate = end.format("YYYY-MM-DDTHH:mm:ss.sss") + "Z";
        if (offset)
            currentFilters.offset += currentFilters.limit;
        else
            currentFilters.offset = 0;

        setFilters({ ...currentFilters })


        currentConditions.push({
            exact: true,
            range: {
                fields: ["unitTime"],
                GTE: currentFilters?.startDate,
                LTE: currentFilters?.endDate
            }
        });

        let payload = {
            conditions: currentConditions,
            limit: currentFilters.limit,
            offset: offset ? currentFilters.offset : 0,
            sort: gridSort || currentFilters.sort,
            oldNextToken: reload ? null : nextToken
        }

        dispatch(searchAiVideoReviewsByAccount(payload));
        setConditions(payload);

        if (!fromPreferences)
            tableRef?.current?.conditionsHandler(currentConditions);
    }

    const closeModal = () => {
        dispatch(reset())
    }

    const accountHandler = (newaccount) => {
        //if (newaccount?.id) dispatch(activitiesSearchUsersRequest(newaccount.id))
        //else dispatch(clearRedux("ACTIVITIES_MAIN", { users: [] }))
        setAccount(newaccount)
    }

    const deviceHandler = (newDevice) => {
        setDevice(newDevice)
    }

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    const getDevicesForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getDevices(input, account?.id).then((response) => {
            callback(response || [])
        })
    }

    const onChangeStartEndDate = ({ start, end }) => {
        const newStart = start && new Date(start);
        const newEnd = end && new Date(end);

        let fltrs = filters;
        fltrs.startDate = newStart;
        fltrs.endDate = newEnd;
        // Set New Date Range
        setStartDate(newStart);
        setEndDate(newEnd);
        if (start && end) {
            const newDateRange = {
                start,
                end,
            };
            setBeforeRangeDate(newDateRange);
        }
        setFilters({ ...fltrs });
    }

    const applyFilters = () => {
        loadInitData(null, null, true);
    }

     useEffect(() => {
        loadInitData();
    }, [])

    useEffect(() => {
        return () => {
            dispatch(reset({ items: [], total: 0 }))
        }
    }, [])

    useEffect(() => {
        let currentColumns = columns.map((item) => ({
            ...item,
            title: messages[item.code],
            render: item.key === "result" ? (item) => {
                return (
                    <Tooltip title={messages['edge_tensor_tab_raw_message']} placement="top">
                        <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon fs-20" onClick={() => {
                            let rawData = cloneDeep(item)
                            if (item?.response) {
                                rawData.response = JSON.parse(item.response);
                            }
                            if (item?.data) {
                                rawData.data = JSON.parse(item.data);
                            }
                            dispatch(rawMessageViewOpenModal(true, rawData, `${messages['edge_tensor_tab_raw_message']} - ${item.rowId}`, false, null))
                        }}>
                            remove_red_eye
                        </Icon>
                    </Tooltip>
                )
            } : item.key === "status" ? (item) => {
                return getBadget(messages[`edge_tensor_tab_status_${item.status.toLowerCase()}`] || item.status, null, item.status);
            } : item.key === "raw_data" ? (item) => {
                return (
                    <Tooltip title={messages['edge_tensor_tab_raw_message']} placement="top">
                        <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon fs-20" onClick={() => {
                            let rawData = cloneDeep(item)
                            try {
                                if (item?.response) {
                                    rawData.response = JSON.parse(item.response);
                                }
                                if (item?.data) {
                                    rawData.data = JSON.parse(item.data);
                                }
                            } catch (error) {
                                console.error("Failed to parse JSON in raw_data renderer:", error);
                            }
                            dispatch(rawMessageViewOpenModal(true, rawData, `${messages['edge_tensor_tab_raw_message']} - ${item.rowId}`, false, null))
                        }}>
                            remove_red_eye
                        </Icon>
                    </Tooltip>
                )
            } : item.key === "review" ? (item) => {
                if (item.status === "Pending")
                    return null

                let data = {
                    rowId: item.rowId,
                    accountId: item.accountId,
                    deviceId: item.deviceId,
                    url: null,
                    eventName: item.eventName,
                    tab: 0
                }

                if (!item?.resultEventNames) {
                    data.onlyVideo = true;
                    return (
                        <Tooltip title={messages['edge_tensor_tab_open_video']} placement="top">
                            <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon fs-20" onClick={() => {
                                dispatch(openModalEdgeTensorVideoReview({ data }))
                            }} >
                                ondemand_video
                            </Icon>
                        </Tooltip>
                    )
                } else
                    return (
                        <Tooltip title={messages['edge_tensor_tab_event_review']} placement="top">
                            <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon fs-20" onClick={() => {
                                if (HasPermission(user, "edgtnsrvdrvrw")) {
                                    dispatch(openModalEdgeTensorVideoReview({ data }))
                                } else {
                                    NotificationManager.warning(
                                        messages['common_error_permission'],
                                        messages['edge_tensor_tab_title'],
                                        5000,
                                    );
                                }
                            }} >
                                assignment
                            </Icon>
                        </Tooltip>
                    )
            } :
                item.render
        }))
        setColumns(currentColumns)

    }, [lang])

    const getMaxDateLimit = () => {
        let maxDateLimit = new Date(startDate);
        if (!endDate) {
            maxDateLimit.setDate(maxDateLimit.getDate() + 7);
            if (maxDateLimit > new Date()) {
                maxDateLimit = new Date();
            }
        } else {
            maxDateLimit = new Date();
        }

        return maxDateLimit;
    }

    const getGridFilter = () => {
        return (
            <div style={{ marginLeft: 10, marginTop: 5 }}>
                <Filters
                    startDate={startDate}
                    endDate={endDate}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    setBeforeRangeDate={setBeforeRangeDate}
                    beforeRangeDate={beforeRangeDate}
                    onChangeFilters={() => loadInitData(null, null, true)}
                    disabled={loading}
                    single={props?.single}
                    module={props?.module}
                    setModule={props?.setModule}
                    last={last}
                    setLast={setLast}
                    type={type}
                    setType={setType}
                    lastOptionsLimit={100}
                    hideTypeSelection={true}
                    notApply={(mode === "tab" || mode === "modal") ? false : true}
                    noClass={(mode === "tab" || mode === "modal") ? false : true}
                    maxDate={getMaxDateLimit()}
                />
            </div>
        )
    }

    const componentRender = () => {

        if (mode !== "modal")
            if (mode !== "tab")
                return getMainListComponent();
            else
                return getMainComponent();
        else
            return getModalComponent();

    }

    const getMainComponent = () => {
        return (
            <>
                <DataView
                    ref={tableRef}
                    columns={columns}
                    exportName="EdgeTensor"
                    name="pm-edge-tensor"
                    entity="edgeTensor"
                    topheight={250}
                    height={(mode === "tab" || mode === "modal") ? height && height + "px" || "600px" : null}
                    externalLoading={loadingEdgeTensor}
                    externalData={items || []}
                    externalDataTotal={total || 0}
                    hidePagination
                    nextToken={nextToken}
                    noFilters
                    noSplit
                    noSearch
                    disableItemSelection
                    setColumns={(items) => setColumns(items)}
                    extraButton={() => {
                        if (mode === "tab" || mode === "modal")
                            return getGridFilter();
                    }}
                    onChangePage={(nextToken, page) => {
                        loadInitData(null, null, false, null, null, false, null, nextToken)
                    }}
                    onChangeRowsPerPage={(rows) => {
                        let fltrs = filters;
                        fltrs.limit = rows;
                        fltrs.page = 1;
                        setFilters({ ...fltrs });
                        loadInitData(fltrs, null, true);
                    }}
                    onExternalSorting={(sort) => {
                        let newsort = [{ field: sort.key, order: sort.order.toUpperCase() }];
                        let fltrs = filters;
                        fltrs.sort = newsort;
                        setFilters({ ...fltrs });
                        loadInitData(fltrs, null, true, null, null, false, newsort);
                    }}
                    externalRefresh={(paggingFilters) => { loadInitData(null, paggingFilters, true) }}
                    tableButtons={["export", 'orderColumn']}
                    onChangeColumns={(items) => setColumns(items)}
                    conditions={conditions}
                    query={getQuery("edge-tensor")}
                    noPDF
                    fixSearchBar
                    onChangeConditions={(tags, conditions, total, newColumns, rows, sort, key, fromPreferences) => {
                        //loadInitData(conditions, null, true, tags, rows, fromPreferences, sort);
                    }}
                    extraFilters={() => {
                        if (mode === "tab" || mode === "modal")
                            return (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div className="extra-filters-tab" style={{ width: '100%', justifyContent: 'end', marginTop: 3 }}>
                                        {
                                            getStatus()
                                        }

                                    </div>
                                    <div style={{ marginLeft: 10, width: 300, marginTop: -25 }}>
                                        <CustomSelect
                                            async
                                            value={device}
                                            onChange={(items) => deviceHandler(items)}
                                            loadOptions={getDevicesForSelect}
                                            loading={loadingDevices}
                                            getOptionLabel={e => e.label?.trim() || e.esn}
                                            getOptionValue={e => e.esn}
                                            placeholder={messages['edge_tensor_tab_device']}
                                            menuPortalTarget={document.body}
                                            styles={selectStyles}
                                        />
                                    </div>
                                </div>
                            );
                    }}
                    hideAllInPagination
                    infiniteScroll
                />
                {openModalRawMessage && <RawMessageView />}
            </>
        );
    }

    const getStatus = () => {
        return (
            <Select
                id="status"
                label={(mode === "tab" || mode === "modal") ? "" : messages['edge_tensor_tab_status']}
                placeholder={messages['edge_tensor_tab_status']}
                options={getEdgeTensorStatusOptions(messages)}
                value={status}
                textField="label"
                valueField="id"
                onChange={(newStatus) => setStatus(newStatus)}
                isClearable
            />
        )
    }

    const getModalComponent = () => {
        if (openModalEdgeTensor) {
            return (
                <Modal
                    open={openModalEdgeTensor}
                    title={`${messages['edge_tensor_tab_title']} - ${account?.name}`}
                    handleClose={() => closeModal()}
                    position="right"
                    loading={loading}
                    size="large"
                >
                    <ModalBody>
                        {getMainComponent()}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn-cancel"
                            onClick={() => closeModal()}
                        >
                            {messages['cancel']}
                        </Button>
                    </ModalFooter>
                </Modal>
            );
        }
    }

    const getMainListComponent = () => {
        return (
            <Container maxWidth={false} className="container-view">
                <Paper elevation={0}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8", height: '95v' }}
                    >
                        <Grid item xs={6}>
                            <Typography variant="h5" gutterBottom component="div">
                                {messages['edge_tensor_tab_title']}
                            </Typography>
                        </Grid>
                        <div style={{ width: '100%', marginBottom: 10, marginTop: 5 }}>
                            <Divider style={{ backgroundColor: '#999999' }} />
                        </div>
                        <Grid
                            container
                            direction="row"
                            spacing={1}
                        >
                            <Grid item xs={3}>
                                <CustomSelect
                                    async
                                    value={account}
                                    onChange={(items) => accountHandler(items)}
                                    label={messages['edge_tensor_tab_account']}
                                    loadOptions={getAccountsForSelect}
                                    loading={loadingAccounts}
                                    getOptionLabel={e => e.name}
                                    getOptionValue={e => e.id}
                                    placeholder={messages['select']}
                                    className="react-select__control"
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                            </Grid>

                            <Grid item xs={3} >
                                <CustomSelect
                                    async
                                    value={device}
                                    onChange={(items) => deviceHandler(items)}
                                    label={messages['edge_tensor_tab_device']}
                                    loadOptions={getDevicesForSelect}
                                    loading={loadingDevices}
                                    getOptionLabel={e => e.label?.trim() || e.esn}
                                    getOptionValue={e => e.esn}
                                    placeholder={messages['select']}
                                    className="react-select__control"
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                            </Grid>

                            <Grid item xs={2}>
                                <div style={{ width: '100%' }}>
                                    <span style={{ marginLeft: 10, fontWeight: "bold" }}>{messages['edge_tensor_tab_date_range']}</span>
                                    {getGridFilter()}
                                </div>
                            </Grid>

                            <Grid item xs={2}>
                                {getStatus()}
                            </Grid>

                            <Grid item xs={2} >
                                <div className="filters-apply" style={{ marginTop: 25, width: '100%' }}>
                                    <Button
                                        style={{ width: '100%' }}
                                        className="btn-dark-blue"
                                        onClick={() => applyFilters(null, true)}
                                    >
                                        {messages['activities_main_apply']}
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                        <div style={{ width: '100%', marginBottom: 10, marginTop: 5 }}>
                            <Divider style={{ backgroundColor: '#999999' }} />
                        </div>
                        {getMainComponent()}
                    </Grid>
                </Paper>
            </Container>
        )
    }

    return (
        <Fragment>
            {componentRender()}
            {edgeTensorVideoReviewOpenModal && <EdgeTensorVideoReview reloadData={loadInitData} />}
        </Fragment>
    );
};

export default TabEdgeTensor;